/**
 * Explore (#explore) – administrace obsahu sekce Explore na Vienna House kiosku.
 * Načítání: GET /getExplore. Přidání: Modal V=6 → POST /uploadExplore (2 soubory: obrázek + QR).
 * Nahrávky se ukládají na server do složky uploads/ a záznam do tabulky cExplore.
 */
import classes from "./Vienna_explore.module.css"
import AddMedia from "../AddMedia";
import {useEffect, useState} from "react";
import ExploreContent from "./ExploreContent";
import ModalView from "../Modal/ModalView";
import axios from "axios";
import { path, assetsBaseUrl } from "../../../routes";
import { Dialog, DialogTitle, DialogContent, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

const Vienna_explore = (props) => {

    const [data, setData] = useState([])
    const [user, setUser] = useState(props.cred);
    const [idCount, setIdCount] = useState(1);
    const [groupid, setGroupid] = useState(1);
    const [currentID, setCurrentID] = useState(null);
    const [cards, setCards] = useState([])
    const [cardsNew, setCardsNew] = useState([]);
    const [modalLoaded, setModalLoaded] = useState(false);
    const [modalVariant, setModalVariant] = useState(null);
    const [images, setImages] = useState([]);
    const [fileContent, setFileContent] = useState('');
    const [radioDown, setradioDown] = useState(0);
    const [radioUp, setradioUp] = useState(0);
    const [previewOpen, setPreviewOpen] = useState(false);
    const [previewData, setPreviewData] = useState(null);
    const [modalBodyUpdate, setmodalBodyUpdate] = useState({
        name: "",
        device: null,
        date: "2020-11-11 00:00:00",
        dateFrom: "2020-11-11 00:00:00",
        dateTo: "2020-11-11 00:00:00",
        room: "A-D"
    })
    const [modalBody, setModalBody] = useState({
        file: "",
        text: "testik",
        v1: false,
        v2: true,
        v3: true
    });

    const delete_hanler = (id) => {
        setCurrentID(id)
        setModalVariant(0)
        setModalLoaded(true)
    }
    const preview_handler = (item) => {
        const norm = (p) => (p || '').replace(/\\/g, '/').replace(/^\/+/, '');
        setPreviewData({
            ...item,
            file1Url: item.file1 ? (item.file1.startsWith('http') ? item.file1 : `${assetsBaseUrl}${norm(item.file1)}`) : '',
            file2Url: item.file2 ? (item.file2.startsWith('http') ? item.file2 : `${assetsBaseUrl}${norm(item.file2)}`) : ''
        })
        setPreviewOpen(true)
    }
    const add_hanler = (id) => {
        setCurrentID(null)
        setModalVariant(6)
        setModalBody(null)
        setModalLoaded(true)
    }
    const modal_close_handler = (id) => {
        setCurrentID(null)
        setModalVariant(null)
        setModalLoaded(false)
        fetch_explore()
        setModalBody(null)
    }
    const add_toCards_handler = (card) => {
        setCards([...cards, card])
        setIdCount(idCount + 1)
    }
    const delete_fnc = async (id) => {

        try {
            await axios.delete(`${path}/deleteExplore/${id}`)
            console.log('Row deleted successfully');
            // Optionally, update your UI to reflect the deletion
        } catch (error) {
            console.error('Error deleting row:', error);
        }
        fetch_explore()

        console.log("deleting id no. ", id)

    }

    const fetch_explore = async () => {
        setData([])
        const dt = new Date
        const date = `${dt.getFullYear()}-${String(dt.getMonth() + 1).padStart(2, "0")}-${String(dt.getDate()).padStart(2, "0")}`
        const actTime = `${dt.getFullYear()}-${String(dt.getMonth() + 1).padStart(2, "0")}-${String(dt.getDate()).padStart(2, "0")}T${String(dt.getHours()).padStart(2, "0")}:${String(dt.getMinutes()).padStart(2, "0")}:${String(dt.getSeconds()).padStart(2, "0")}`;
        try {
            const response = await axios.get(`${path}/getExplore`);
            setData(response.data)
        } catch (error) {
            console.log(error)

        }

    }

    useEffect(() => {
        fetch_explore()
    }, [])

    return <div className={classes.main}>
        {data.length >= 1 && data.map((item) => (
            <ExploreContent
                key={item.id}
                data={item}
                delete={delete_fnc}
                preview={preview_handler}
            />
        ))}
        {data.length < 3 && <AddMedia click={add_hanler}/>}
        {modalLoaded &&
            <ModalView V={modalVariant} ModalBody={modalBody} close={modal_close_handler} add={add_toCards_handler}
                       addID={idCount} currentID={currentID} delFNC={delete_fnc} cred={user}
                       modalBodyUpdate={modalBodyUpdate} groupID={groupid}/>}
        <Dialog open={previewOpen} onClose={() => setPreviewOpen(false)} maxWidth="sm" fullWidth PaperProps={{ className: classes.previewDialog }}>
            <DialogTitle sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap', gap: 1 }}>
                <span>{previewData?.header || 'Preview'}</span>
                <IconButton aria-label="close" onClick={() => setPreviewOpen(false)} size="small"><CloseIcon /></IconButton>
            </DialogTitle>
            <DialogContent className={classes.previewContent}>
                {previewData && (
                    <>
                        <div className={classes.previewRow}>
                            {previewData.file1Url && (
                                <div className={classes.previewImgWrap}>
                                    <img src={previewData.file1Url} alt={previewData.header || ''} />
                                </div>
                            )}
                            <div className={classes.previewText}>{previewData.content || '–'}</div>
                        </div>
                        {previewData.file2Url && (
                            <div className={classes.previewQr}>
                                <span>QR</span>
                                <img src={previewData.file2Url} alt="QR" />
                            </div>
                        )}
                    </>
                )}
            </DialogContent>
        </Dialog>
    </div>
}

export default Vienna_explore;